'use client';

import { Breadcrumb } from '@/components/ui/breadcrumb.component';
import ErrorState from '@/app/(main)/_components/error-state/error-state';

export default function Error({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <>
      <Breadcrumb
        list={[
          {
            label: 'Profissionais',
            href: '/profissionais/',
          },
          {
            label: 'Erro',
          },
        ]}
      />
      <ErrorState
        description="Não conseguimos carregar as informações do profissional. Verifique sua conexão ou tente novamente clicando no botão abaixo:"
        onReset={reset}
      />
    </>
  );
}
